export default __webpack_public_path__ + "static/media/img-0393-serbia-full-face.4bc01a27.png";